export enum ColumnIds {
  Id = 'id',
  PlayerId = 'playerId',
  DrawId = 'drawId',
  Name = 'name',
  FullName = 'fullName',
  TeamName = 'competitor.name',
  SportId = 'sport.id',
  SportName = 'sport.name',
  Venue = 'venue.name',
  VenueId = 'venue.id',
  GenderType = 'genderType',
  Gender = 'gender',
  AgeCategory = 'ageCategory',
  StartDate = 'startDate',
  EndDate = 'endDate',
  CompetitionId = 'competition.id',
  SeasonId = 'season.id',
  ParentRoundId = 'parentRound.id',
  ParentGroupId = 'parentGroup.id',
  IsProtected = 'isProtected',
  ShirtNumber = 'shirtNumber',
  Position = 'position',
  Type = 'type',
  Actions = 'actions',
  DateActions = 'dateActions',
  LocalityName = 'locality.name',
  DateOfBirth = 'dateOfBirth',
  CompetitorStatusType = 'competitorStatusType',
  SourceName = 'sourceName',
  CreatedOn = 'createdOn',
  Status = 'status',
  StatusDetails = 'statusDetails',
  FirstRequestCreatedOn = 'firstRequestCreatedOn',
  GeniusSportId = 'geniusSportId',
  GeniusSportSportId = 'geniusSportSportId',
  ModifiedOn = 'modifiedOn',
  SourceEntityId = 'sourceEntityId',
  RequestCuratedValueSport = 'requestCuratedValue.sport',
  RequestCuratedValueLocality = 'requestCuratedValue.competition.localityExtend',
  GSCompetitionId = 'geniusSportCompetitionId',
  SourceCompetitionId = 'sourceCompetitionId',
  AllowsDoubles = 'allowsDoubles',
  AllowsPlayers = 'allowsPlayers',
  ShouldApplyFixtureLegRule = 'shouldApplyFixtureLegRule',
  HasDraws = 'hasDraws',
  MaxNumberOfCompetitorsInFixture = 'maxNumberOfCompetitorsInFixture',
  EventCompetitorMinimumMatchDifference = 'eventCompetitorMinimumMatchDifference',
  RecreateEventsThreshold = 'recreateEventsThreshold',
  LineUpStartingPlayersCount = 'lineUpStartingPlayersCount',
  Code = 'code',
  IsNationalTeam = 'metadataProperties.IsNationalTeam',
  GsEntityId = 'gsEntityId',
  Aliases = 'aliases',
  SportNameObject = 'matchedSport.name',
  FixtureStatusType = 'fixtureStatusType',
  CompetitionName = 'competition.name',
  SeasonName = 'season.name',
  Priority = 'sourcePriority',
  LastSourceUpdateDate = 'lastSourceUpdate',
}
